// @flow
import type {Node} from 'react'
import React, {Suspense, useCallback, useState} from 'react'

import preloadedLazy from 'utils/MiscUtils/preloadedLazy'
import ModalLoader from 'components/ui/ModalLoader'
import QuickAddButton from 'components/SideBar/ui/QuickAddButton'

// GF-2954: the proposal quick-add opener is the second modal-opener island.
// The server decides whether the viewer may add a proposal (SideBarPresenter
// mirrors viewer_can_add_proposal) — this island only renders when they may,
// so it needs no Relay query of its own. ProposalCreator receives plain ids.
const LazyProposalCreator = preloadedLazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: "ProposalCreator" */
  'components/pages/Proposals/ProposalsView/ProposalCreator'
))

type Props = $ReadOnly<{
  orgDatabaseId: string,
}>

function ProposalOpenerIsland({orgDatabaseId}: Props): Node {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const toggle = useCallback(async () => setIsOpen(false), [])

  return (
    <React.Fragment>
      <QuickAddButton
        onClick={open}
        alt={I18n.t('side_nav.tension_processing.add_proposals')}
      />
      {isOpen && (
        <Suspense fallback={<ModalLoader />}>
          <LazyProposalCreator
            orgDatabaseId={orgDatabaseId}
            tensionDatabaseId={null}
            toggle={toggle}
          />
        </Suspense>
      )}
    </React.Fragment>
  )
}

export default ProposalOpenerIsland
